import React from "react";
import Modal from "react-awesome-modal";
import Link from "next/link";

/* 보관함 모달 */
const ArchiveModal = ({ modalVisible, closeModal }) => {
  return (
    <Modal visible={modalVisible} width="450" height="250" effect="fadeInUp" onClickAway={() => closeModal()}>
      <div className="popup-wrap">
        <div className="popup-content">
          <div className="popup-header"></div>
          <div className="popup-body flex flex-col justify-center items-center">
            <h3 className="text-2xl text-primary font-bold font-gmarket-medium" id="modal-title">
              내 보관함에 추가되었습니다
            </h3>
            <p className="mb-0 text-888 font-gmarket-medium">보관된 앱은 보관함 메뉴에서 확인 가능합니다</p>
          </div>
          <div className="popup-footer">
            <button type="button" className="btn btn-modal-o w-1/2 mr-2" onClick={() => closeModal()}>
              확인
            </button>
            <Link href="/archive">
              <div className="btn btn-grayPrimary w-1/2">보관함으로</div>
            </Link>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ArchiveModal;
